namespace GeniuzPOS.Purchase {
    export class PoCNRTVAppColumns {
        static columnsKey = 'Purchase.PoCNRTVApp';
    }
}
